import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';
import ProductPageSelect from '../components/productPage/ProductPageSelect/ProductPageSelect';
import ProductConfigurationList from './ProductConfigurationList';
import { hideOnPrint } from "../styles/helpers/mixins";
import { SITE_ROOT_URL } from '../constants/endpoints';

const ProductConfiguration = props => {
  const selectedVariantMatchesURL = !!props.data.filter(variant => variant.get('url') === props.location).size;
  const currentSelectedVariant = props.data.find(variant => variant.get('url') === props.location);

  if (!selectedVariantMatchesURL) {
    // TODO: Reset selected product variant if !selectedVariantMatchesURL
    return false;
  }

  const { data, optionsData, selectedOptions, isMobileDevice, currentProduct } = props;

  if (!data || !optionsData || !selectedOptions || !props.selected || (data.size <= 1 && optionsData.size === 0)) return false;

  let totalSelectedOptionPrice = 0;
  const optionsListMobile = props.optionsData
    .map(option => {
      const selectedOptionId = props.selectedOptions[option.get('name')];

      if (!selectedOptionId) {
        return false;
      }

      const selectedOptionsObject = {
        name: option.get('options').find(item => item.get('id') === selectedOptionId).get('name'),
        image: SITE_ROOT_URL + option.get('options').find(item => item.get('id') === selectedOptionId).getIn(['images', 0, 'url']),
        price: option.get('options').find(item => item.get('id') === selectedOptionId).get('price'),
      };

      if (!selectedOptionsObject.name || !selectedOptionsObject.image) {
        return false;
      }

      totalSelectedOptionPrice += selectedOptionsObject.price;

      return (
        <ProductConfigurationContainer key={option.get('name')}>
          <ProductConfigurationList
            fullImages
            title={option.get('name')}
            type={option.get('name')}
            location={props.location}
            selected={selectedOptionId}
            selectedOptionPrice={selectedOptionsObject.price}
            setProductVariant={props.setProductOption}
            isMobileDevice={isMobileDevice}
            price={props.price}
          >
            {option.get('options')}
          </ProductConfigurationList>
        </ProductConfigurationContainer>
      )
    }).toArray();

  const VariantListMobile = () => (
    <ProductConfigurationContainer key="Utförande">
      <ProductConfigurationList
        title={currentProduct.get('variantHeading') || 'Utförande'}
        isMobileDevice={isMobileDevice}
        selected={props.selected}
        location={props.location}
        setProductVariant={props.setProductVariant}
        price={props.price}
        totalSelectedOptionPrice={totalSelectedOptionPrice}
      >
        {data}
      </ProductConfigurationList>
    </ProductConfigurationContainer>
  );

  const mergedMobile = [VariantListMobile(), ...optionsListMobile];

  if (isMobileDevice) {
    return (
      <div>
        {mergedMobile}
      </div>
    );
  }

  let totalSelectedOptionPrice2 = 0;
  const optionsList = props.optionsData
    .map(option => {
      const selectedOptionId = props.selectedOptions[option.get('name')];

      if (!selectedOptionId) {
        return false;
      }

      const selectedOptions2 = {
        name: option.get('options').find(item => item.get('id') === selectedOptionId).get('name'),
        image: SITE_ROOT_URL + option.get('options').find(item => item.get('id') === selectedOptionId).getIn(['images', 0, 'url']),
        price: option.get('options').find(item => item.get('id') === selectedOptionId).get('price'),
      };

      if (!selectedOptions2.name || !selectedOptions2.image) {
        return false;
      }

      totalSelectedOptionPrice2 += selectedOptions2.price;
      return (
        <ProductPageSelect
          key={selectedOptions2.name}
          type={option.get('name')}
          label={option.get('name')}
          title={selectedOptions2.name}
          image={selectedOptions2.image}
          selectedOptionPrice={selectedOptions2.price}
          selected={selectedOptionId}
          location={props.location}
          setProductVariant={props.setProductOption}
          options={option.get('options')}
          price={props.price}
        />
      )
    }).toArray();

  const selectedVariant = {
    name: currentSelectedVariant.get('cleanVariantName'),
    image: SITE_ROOT_URL + currentSelectedVariant.getIn(['mainImage', 'url']),
  };

  const VariantList = () => (
    <ProductPageSelect
      key="variant"
      type="variant"
      label={currentProduct.get('variantHeading')}
      title={selectedVariant.name}
      image={selectedVariant.image}
      selected={props.selected}
      location={props.location}
      setProductVariant={props.setProductVariant}
      options={data}
      price={props.price}
      totalSelectedOptionPrice={totalSelectedOptionPrice2}
    />
  );

  const combinedArrayOfVariantsAndOptions = [VariantList(), ...optionsList].filter(item => item !== false);

  return (
    <ProductConfigurationContainer>
      {combinedArrayOfVariantsAndOptions}
    </ProductConfigurationContainer>
  );
};

const ProductConfigurationContainer = styled.div`
  ${hideOnPrint};
  width: 100%;
  margin: 0 0 30px;
`;

ProductConfiguration.defaultProps = {
  isMobileDevice: false,
  selected: '',
  optionsData: List(),
  selectedOptions: [],
  currentProduct: Map(),
  price: null,
};

ProductConfiguration.propTypes = {
  selected: PropTypes.string,
  setProductVariant: PropTypes.func.isRequired,
  setProductOption: PropTypes.func.isRequired,
  isMobileDevice: PropTypes.bool,
  data: PropTypes.oneOfType([PropTypes.instanceOf(Map), PropTypes.instanceOf(List)]).isRequired,
  optionsData: PropTypes.instanceOf(List),
  selectedOptions: PropTypes.object,
  location: PropTypes.string.isRequired,
  currentProduct: PropTypes.instanceOf(Map),
  price: PropTypes.number,
};

export default ProductConfiguration;



// WEBPACK FOOTER //
// ./src/components/ProductConfiguration.js